import React from 'react'
import styles from '../UIGameBarbarianInvasionTracker.module.scss'
import {T, Tooltip} from '@colonist/ui'
import clsx from 'clsx'
import {type TranslationObject} from '@colonist/i18n'
import IconSwords from '@static/images/icon_swords.svg'

export interface UIGameBarbarianInvasionTrackerKnightProps {
    knightStrength: number
    arePlayersWinning: boolean
    className?: string
}

const tooltipContent: TranslationObject[] = [
    {key: 'strings:game.tips.knight.body.0'},
    {key: 'strings:game.tips.knight.body.1'},
]

export const UIGameBarbarianInvasionTrackerKnight = ({
    knightStrength,
    arePlayersWinning,
    className,
}: UIGameBarbarianInvasionTrackerKnightProps) => (
    <Tooltip
        className={clsx(styles.iconWrapper, className)}
        content={
            <>
                {tooltipContent.map((item, i) => (
                    <div className={styles.tooltipItem} key={i}><T id={item} /></div>
                ))}
            </>
        }
        delay={0}
        menuClassName={styles.tooltipMenu}
        position="bottom-start"
        title={<T id={{key: 'strings:game.tips.knight.title'}} />}
    >
        <img className={styles.icon} src={IconSwords} />
        <div className={clsx(styles.iconBadge, {
            [styles.green]: arePlayersWinning,
            [styles.red]: !arePlayersWinning,
        })}>
            <span>{knightStrength}</span>
        </div>
    </Tooltip>
)
